module.exports = __webpack_public_path__ + "static/media/photo57.14e01136.jpg";